"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Certifier = void 0;
const useStore_entities_1 = require("../../contexts/useStore/useStore.entities");
class Certifier extends useStore_entities_1.Entity {
    static cache = true;
    static all = () => ({
        api: 'v1',
        method: 'GET',
        route: '/certifiers',
    });
}
exports.Certifier = Certifier;
//# sourceMappingURL=Certifier.js.map